import wildcard from 'wildcard'

export const useSchoolExternalIntegrations = () => {
  const integrationPathIsValid = (
    integrationPaths: string[],
    currentUrl: string,
  ) => {
    const isValid = false
    for (let i = 0; i < integrationPaths.length; i++) {
      const path = integrationPaths[i]
      if (wildcard(path, currentUrl)) {
        return true
      }
    }
    return isValid
  }

  return {
    integrationPathIsValid,
  }
}
